import { createAsyncThunk } from '@reduxjs/toolkit'
import {
    SanctionArchiveUpdateApi,
    SanctionGrandTotalApi,
    SanctionPurchaseListApi,
    SanctionShowDateUpdateApi,
    SanctionShowNameUpdateApi,
    SanctionHostNameUpdateApi,
    SanctionSecretaryNameUpdateApi,
    SanctionSecretaryEmailUpdateApi,
    SanctionTypeUpdateApi,
    SanctionArbaNumberUpdateApi,
    SanctionSecretaryAddressUpdateApi,
    SanctionShowAddressUpdateApi
} from './SanctionPurchaseList.services'
import { paginationData } from '../Pagination/reducers'

export const SanctionPurchaseList = createAsyncThunk(
    'Sanction/list/club',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const res = await SanctionPurchaseListApi(data)

            if (Number(data?.params?._limit || 0) > 1) {
                // Pagination Section
                const limit = data.params._limit || 10
                const TotalPage = Math.ceil(res.totalRecords / limit) || 1
                const paginationObj = {
                    page: data.params?._page || 1,
                    totalPage: TotalPage || 1,
                    totalRecords: res?.totalRecords || 1
                }
                dispatch(paginationData(paginationObj))
            }

            return res.data
        } catch (err) {
            if (Number(data?.params?._limit || 0) > 1) {
                const paginationObj = {
                    page: 1,
                    totalPage: 1,
                    totalRecords: 1
                }
                dispatch(paginationData(paginationObj))
            }

            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const SanctionGrandTotal = createAsyncThunk(
    'Sanction/GrandTotal',
    async (data, { rejectWithValue }) => {
        try {
            const res = await SanctionGrandTotalApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)
export const SanctionShowDateUpdate = createAsyncThunk(
    'Sanction/Update/Show-date',
    async (data, { rejectWithValue }) => {
        try {
            const res = await SanctionShowDateUpdateApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const SanctionShowNameUpdate = createAsyncThunk(
    'Sanction/Update/Show-name',
    async (data, { rejectWithValue }) => {
        try {
            const res = await SanctionShowNameUpdateApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const SanctionHostNameUpdate = createAsyncThunk(
    'Sanction/Update/Host-name',
    async (data, { rejectWithValue }) => {
        try {
            const res = await SanctionHostNameUpdateApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const SanctionSecretaryNameUpdate = createAsyncThunk(
    'Sanction/Update/Secretary-name',
    async (data, { rejectWithValue }) => {
        try {
            const res = await SanctionSecretaryNameUpdateApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const SanctionSecretaryEmailUpdate = createAsyncThunk(
    'Sanction/Update/Secretary-email',
    async (data, { rejectWithValue }) => {
        try {
            const res = await SanctionSecretaryEmailUpdateApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const SanctionTypeUpdate = createAsyncThunk(
    'Sanction/Update/Sanction-type',
    async (data, { rejectWithValue }) => {
        try {
            const res = await SanctionTypeUpdateApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const SanctionArbaNumberUpdate = createAsyncThunk(
    'Sanction/Update/Arba-number',
    async (data, { rejectWithValue }) => {
        try {
            const res = await SanctionArbaNumberUpdateApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const SanctionSecretaryAddressUpdate = createAsyncThunk(
    'Sanction/Update/Secretary-address',
    async (data, { rejectWithValue }) => {
        try {
            const res = await SanctionSecretaryAddressUpdateApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const SanctionShowAddressUpdate = createAsyncThunk(
    'Sanction/Update/Show-address',
    async (data, { rejectWithValue }) => {
        try {
            const res = await SanctionShowAddressUpdateApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const SanctionArchiveUpdate = createAsyncThunk(
    'Sanction/Update/archive',
    async (data, { rejectWithValue }) => {
        try {
            const res = await SanctionArchiveUpdateApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)